export default __webpack_public_path__ + "static/media/doc.c5bdff32.svg";